let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lWioM")).then(() => parcelRequire('7oUTT'));